import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { Toaster } from "@/components/ui/sonner";

import { PublicLayout } from "@/components/PublicLayout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Portfolio from "@/pages/Portfolio";
import Clients from "@/pages/Clients";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import News from "@/pages/News";
import Careers from "@/pages/Careers";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import ContentPage from "@/pages/admin/ContentPage";
import CopSurat from "@/pages/admin/CopSurat";
import DocumentManager from "@/pages/admin/DocumentManager";
import SettingsPage from "@/pages/admin/SettingsPage";
import ChangePassword from "@/pages/admin/ChangePassword";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <SettingsProvider>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/layanan" element={<Services />} />
              <Route path="/portofolio" element={<Portfolio />} />
              <Route path="/klien" element={<Clients />} />
              <Route path="/tentang" element={<About />} />
              <Route path="/kontak" element={<Contact />} />
              <Route path="/berita" element={<News />} />
              <Route path="/karir" element={<Careers />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="berita" element={<ContentPage configKey="berita" />} />
              <Route path="portofolio" element={<ContentPage configKey="portofolio" />} />
              <Route path="testimoni" element={<ContentPage configKey="testimoni" />} />
              <Route path="karir" element={<ContentPage configKey="karir" />} />
              <Route path="produk" element={<ContentPage configKey="produk" />} />
              <Route path="layanan" element={<ContentPage configKey="layanan" />} />
              <Route path="cop-surat" element={<CopSurat />} />
              <Route path="invoice" element={<DocumentManager mode="invoices" />} />
              <Route path="kwitansi" element={<DocumentManager mode="receipts" />} />
              <Route path="pengaturan" element={<SettingsPage />} />
              <Route path="ganti-password" element={<ChangePassword />} />
            </Route>
          </Routes>
          <Toaster position="top-right" richColors theme="dark" />
        </SettingsProvider>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
